import {GitHubAvatar} from '@github-ui/github-avatar'
import type {AssigneePickerAssignee$data as Assignee} from '@github-ui/item-picker/assignee'
import {userHovercardPath} from '@github-ui/paths'
import {ActionList} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

export type AssigneesProps = {
  assignees: Assignee[]
  sx?: BetterSystemStyleObject
}

export function Assignees({assignees}: AssigneesProps) {
  return (
    <ActionList sx={{py: 0}}>
      {assignees.sort(sortByLogin).map(assignee => (
        <ActionList.LinkItem
          sx={{mx: 0, width: '100%'}}
          key={assignee.id}
          href={`/${assignee.login}`}
          target="_blank"
          data-hovercard-url={userHovercardPath({owner: assignee.login})}
        >
          <ActionList.LeadingVisual>
            <GitHubAvatar
              src={assignee.avatarUrl}
              size={20}
              alt={`@${assignee.login}`}
              key={assignee.id}
              sx={{boxShadow: '0 0 0 2px var(--bgColor-muted, var(--color-canvas-subtle))'}}
            />
          </ActionList.LeadingVisual>
          {assignee.login}
        </ActionList.LinkItem>
      ))}
    </ActionList>
  )
}

function sortByLogin(a: Assignee, b: Assignee) {
  return a.login === b.login ? 0 : a.login > b.login ? 1 : -1
}

try{ Assignees.displayName ||= 'Assignees' } catch {}